import React from 'react';
import { connect } from 'react-redux';

import ComponentWrapper from '../../common/ComponentWrapper';
import CommonStyles from '../../common/CommonStyles';
import { withStyles } from '@mui/styles';
import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';

const styles = {
  ...CommonStyles,
  tableTitle: {
    padding: '6px 16px',
    fontWeight: 'bold',
    fontSize: '12px',
  },
  tableCell: {
    padding: '6px 16px',
    fontSize: '12px',
  },
};

class TimeZones extends ComponentWrapper {
  state = {
    timezones: [],
  };

  componentDidMount() {
    this.get({
      url: `/meta_query?meta_query=["timezones_full"]`,
      cb: ({ _meta_query }) => {
        const timezones = _meta_query.timezones_full || [];
        this.setState({ timezones });
      }
    });
  };

  render() {
    const {
      classes,
    } = this.props;

    const {
      timezones,
    } = this.state;

    return (
      <div className={`${classes.container} ${classes.mb50} ${classes.inlineFlex}`}>
        <Table
          style={{
            background: '#fff'
          }}
          className={classes.mb20}
        >
          <TableHead>
            <TableRow>
              <TableCell className={classes.tableTitle}>#</TableCell>
              <TableCell className={classes.tableTitle}>Time Zone</TableCell>
              <TableCell className={classes.tableTitle}>Local Date & Time</TableCell>
              <TableCell className={classes.tableTitle}>DST usage</TableCell>
              <TableCell className={classes.tableTitle}>Is Daylight Time</TableCell>
              <TableCell className={classes.tableTitle}>UTC</TableCell>
              <TableCell className={classes.tableTitle}>DST start</TableCell>
              <TableCell className={classes.tableTitle}>DST end</TableCell>
              <TableCell className={classes.tableTitle}>Shift</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {Object.values(timezones).map((timezone, indexTimezone) => {
              return (
                <TableRow key={indexTimezone}>
                  <TableCell
                    className={classes.tableCell}
                  >
                    {`${indexTimezone + 1}`}
                  </TableCell>
                  {Object.values(timezone).map((el, indexEl) => {
                    return (
                      <TableCell
                        key={indexEl}
                        className={classes.tableCell}
                      >
                        {indexEl === 2
                          ? el ? 'Yes' : 'No'
                          : el ? el : '-'}
                      </TableCell>
                    );
                  })}
                </TableRow>
              );
            })
            }
          </TableBody>
        </Table>
      </div>
    );
  };
}

export default connect()(withStyles(styles)(TimeZones));